var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.964722H513V342.957H0V0.964722Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.964722H513V114.962H0V0.964722ZM0 228.96H513V342.957H0V228.96Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.967L0 342.962V0.95874L256.5 171.967Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.639 142.221L310.021 164.939H333.91L314.584 178.983L321.965 201.701L302.639 187.659L283.314 201.701L290.695 178.983L271.369 164.939H295.258L302.639 142.221ZM376.987 142.221L384.368 164.939H408.257L388.931 178.983L396.313 201.701L376.987 187.659L357.661 201.701L365.043 178.983L345.717 164.939H369.606L376.987 142.221Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.960693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSt);
export default __webpack_public_path__ + "static/media/ST.0c73b8ddbba36fa60f7ce4c3bf796835.svg";
export { ForwardRef as ReactComponent };